import { render } from "./InviteView.vue?vue&type=template&id=2055a96a"
import script from "./InviteView.vue?vue&type=script&lang=js"
export * from "./InviteView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__